import React, { useState } from "react";
import Card from "react-bootstrap/Card";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import {
  ChevronUp,
  ChevronDown,
  Trash2,
  Eye,
  Edit3
} from "lucide-react";
import ReactMarkdown from "react-markdown";

export default function ContentSectionEditor({
  section,
  index,
  totalSections,
  onChange,
  onMoveUp,
  onMoveDown,
  onDelete,
  t
}) {
  const [showPreview, setShowPreview] = useState(false);

  const handleFieldChange = (field, value) => {
    onChange({ ...section, [field]: value });
  };

  return (
    <Card className="mb-3 border">
      <Card.Header className="bg-light d-flex justify-content-between align-items-center py-2">
        <div className="d-flex align-items-center gap-2">
          <span className="badge bg-secondary">{index + 1}</span>
          <span className="fw-medium text-truncate" style={{ maxWidth: "300px" }}>
            {section.title || (t?.contentCreator?.untitledSection || "Unbenannter Abschnitt")}
          </span>
        </div>
        <div className="d-flex gap-1">
          <Button
            variant="outline-secondary"
            size="sm"
            onClick={() => setShowPreview(!showPreview)}
            title={showPreview ? (t?.contentCreator?.editMode || "Bearbeiten") : (t?.contentCreator?.preview || "Vorschau")}
          >
            {showPreview ? <Edit3 size={14} /> : <Eye size={14} />}
          </Button>
          <Button
            variant="outline-secondary"
            size="sm"
            onClick={onMoveUp}
            disabled={index === 0}
            title={t?.contentCreator?.moveUp || "Nach oben"}
          >
            <ChevronUp size={14} />
          </Button>
          <Button
            variant="outline-secondary"
            size="sm"
            onClick={onMoveDown}
            disabled={index === totalSections - 1}
            title={t?.contentCreator?.moveDown || "Nach unten"}
          >
            <ChevronDown size={14} />
          </Button>
          <Button
            variant="outline-danger"
            size="sm"
            onClick={onDelete}
            title={t?.common?.delete || "Löschen"}
          >
            <Trash2 size={14} />
          </Button>
        </div>
      </Card.Header>
      <Card.Body>
        {showPreview ? (
          <div className="markdown-preview p-3 bg-white rounded border">
            <h5>{section.title}</h5>
            <ReactMarkdown>{section.markdown || ""}</ReactMarkdown>
          </div>
        ) : (
          <>
            <Row className="mb-3">
              <Col md={8}>
                <Form.Group>
                  <Form.Label>{t?.contentCreator?.sectionTitle || "Abschnitt-Titel"}</Form.Label>
                  <Form.Control
                    type="text"
                    value={section.title || ""}
                    onChange={(e) => handleFieldChange("title", e.target.value)}
                    placeholder={t?.contentCreator?.sectionTitlePlaceholder || "z.B. 1.1 Einführung"}
                  />
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group>
                  <Form.Label>{t?.contentCreator?.sectionId || "Abschnitt-ID"}</Form.Label>
                  <Form.Control
                    type="text"
                    value={section.id || ""}
                    onChange={(e) => handleFieldChange("id", e.target.value)}
                    placeholder="z.B. M1_L1_S1"
                  />
                </Form.Group>
              </Col>
            </Row>
            <Form.Group>
              <Form.Label>{t?.contentCreator?.markdownContent || "Inhalt (Markdown)"}</Form.Label>
              <Form.Control
                as="textarea"
                rows={8}
                value={section.markdown || ""}
                onChange={(e) => handleFieldChange("markdown", e.target.value)}
                placeholder={t?.contentCreator?.markdownPlaceholder || "Markdown-Text eingeben...\n\n**Fett**, *kursiv*, Listen mit - oder 1."}
                style={{ fontFamily: "monospace", fontSize: "0.9rem" }}
              />
              <Form.Text className="text-muted">
                {t?.contentCreator?.markdownHint || "Unterstützt Markdown: **fett**, *kursiv*, Listen, Links"}
              </Form.Text>
            </Form.Group>
          </>
        )}
      </Card.Body>
    </Card>
  );
}
